module.exports = __webpack_public_path__ + "img/insurance-logo-12.1aed84b1.png";